"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormWriter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const react_jsonschema_form_1 = __importDefault(require("react-jsonschema-form"));
const validate_1 = __importDefault(require("./validate"));
const formTemplates_1 = require("../../formTemplates");
const widgets_1 = __importDefault(require("./widgets"));
const fields_1 = __importDefault(require("./fields"));
const writer_style_1 = __importDefault(require("./writer.style"));
const workflowContext_1 = require("../../../utils/workflowContext");
class FormWriter extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            onErrorTriggered: false,
            blurredFields: []
        };
        this.validate = validate_1.default(this.props.schema, this.props.uiSchema);
        this.onError = errors => {
            const { formData, onChange } = this.props;
            onChange({ formData, errors });
            this.setState({ onErrorTriggered: true });
            // check if a callback has been provided in the props
            const onErrorProp = this.props.onError;
            if (onErrorProp)
                onErrorProp(errors);
        };
        this.transformErrors = errors => errors.map(error => {
            if (error.name === 'pattern')
                error.message = 'should match the format';
            return error;
        });
        this.onBlurHandler = id => {
            const { blurredFields } = this.state;
            const newBlurredFields = [...blurredFields];
            if (!newBlurredFields.includes(id)) {
                newBlurredFields.push(id);
                this.setState({ blurredFields: newBlurredFields });
            }
        };
    }
    render() {
        const { classes, className, id, schema, uiSchema, disabled, children, formData, onChange, onSubmit, uploadFile, uploadConfig, links, workflowContext } = this.props;
        const { blurredFields, onErrorTriggered } = this.state;
        const context = {
            uploadFile,
            uploadConfig,
            onErrorTriggered,
            blurredFields,
            onBlur: this.onBlurHandler,
            links,
            workflowContext
        };
        const customFormats = {
            'workflow-group': workflowContext_1.workflowGroupCustomFormat(workflowContext)
        };
        return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classnames_1.default(className, classes.root) }, { children: jsx_runtime_1.jsx(react_jsonschema_form_1.default, Object.assign({ id: id, idPrefix: id, schema: schema, uiSchema: uiSchema, widgets: widgets_1.default, fields: fields_1.default, FieldTemplate: formTemplates_1.FieldTemplate, ObjectFieldTemplate: formTemplates_1.ObjectFieldTemplate, ArrayFieldTemplate: formTemplates_1.ArrayFieldTemplate, formData: formData || {}, formContext: context, disabled: disabled, noHtml5Validate: true, onError: this.onError, transformErrors: this.transformErrors, liveValidate: true, validate: this.validate, customFormats: customFormats, showErrorList: false, onChange: onChange, onSubmit: onSubmit }, { children: children }), void 0) }), void 0) }, void 0));
    }
}
exports.FormWriter = FormWriter;
FormWriter.defaultProps = {
    className: '',
    // Pass empty div to disable submit button by default
    children: jsx_runtime_1.jsx("div", {}, void 0),
    formData: {},
    disabled: false
};
exports.default = react_jss_1.default(writer_style_1.default)(FormWriter);
//# sourceMappingURL=index.js.map